import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { IAppState } from '@main-client/src/app/app.state';
import { currentGroupSource } from '@main-client/src/app/group-view/group-view.helper';
import {
  isAdminOfGroup,
  isTenantAdmin,
} from '@main-client/src/app/user/user.helpers';

import { UserService } from '../user/user.service';

import { isEmpty } from 'lodash-es';

export function pathwaysGuard(): CanActivateFn {
  return () => {
    const store = inject(Store<IAppState>);
    const router = inject(Router);
    const destroy$ = new Subject<boolean>();
    const currentGroupSource$ = currentGroupSource(store, destroy$);
    const tenant$ = store
      .select('tenant')
      .pipe(filter((tenant) => !isEmpty(tenant)));
    const user$ = store.select('user').pipe(filter((user) => !isEmpty(user)));
    const userService = inject(UserService);
    return combineLatest([tenant$, currentGroupSource$, user$]).pipe(
      take(1),
      map(([tenant, group, user]) => {
        destroy$.next(true);
        const isPathwayManager = userService
          .userAdminStates()
          .pathwayManagerInGroupIds.includes(group._id);
        if (
          (isTenantAdmin(user) ||
            isAdminOfGroup(user, group) ||
            isPathwayManager) &&
          tenant.enabled_features?.pathways &&
          group.features_enabled?.pathways
        ) {
          return true;
        }
        return router.createUrlTree(['/']);
      }),
    );
  };
}
